export const mixins = {
	data() {
		return {}
	},
	computed: {},
	created() { },
	mounted() {
		let WOW = this.$wow;
		let wow = new WOW({
			boxClass: 'wow', //需要执行动画的元素的 class
			animateClass: 'animated', //animation.css 动画的 class
			offset: 0, //距离可视区域多少开始执行动画
			mobile: true, //是否在移动设备上执行动画
			live: false, //异步加载的内容是否有效
		});
		wow.init();
	},
	methods: {
		closeDialog() {
			//mixin混入
			// this.loginDialog = false;
		},

		// openLoginDialog() {
		// 	mixin混入
		// 	this.loginDialog = true;
		// },
	},
};
